<template>
    <div class="search-wrap">
        <!--    内容    -->
        <div class="search-content">
            <ul>
                <li v-for="item in lists" :key="item.id" >
                    <img :src="item.picUrl" alt="" srcset="">
                    <p class="line-clamp1">{{ item.title }}</p>
                </li>
            </ul>
            <div class="none-data" v-if="!lists.length">暂无数据~</div>
            <el-pagination
                background
                class="pagination"
                layout="prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, reactive, toRefs } from 'vue'
    import { useRoute, useRouter } from 'vue-router/composables'
    import {articleLists} from '../api/index'
    import moment from 'moment'

    const router = useRouter()


    const state = reactive({
        lists:[],
        detail:{},
        total:0,
        page:1,
        pageSize:10,
    })


    // 获取列表
    const getLists = ()=>{
        const data={
            pageNo:state.page,
            pageSize:state.pageSize,
            categoryId:2
        }
         articleLists(data).then(({data})=>{
            const _data = data?.list || []

            _data.forEach(element => {
                element.year = moment(element.createTime).format('YYYY')
                element.month = moment(element.createTime).format('MM')
                element.day = moment(element.createTime).format('DD')
            });

            state.lists = _data
            state.detail = _data[0] || {}
            state.total = data.total
        })
    }

    // 分页页数更改的时候
    const handleCurrentChange =(val)=>{
        state.page = val
        getLists()
    }

    const handleClick =(item)=>{
        if(item.wechatUrl){
            window.open(item.wechatUrl,'_blank')
        }else {
            router.push('/information/detail?id='+item.id)
        }
    }

    const {lists,detail,total,page} = toRefs(state)


    onMounted(() => {

     getLists()

    })

</script>

<style lang="scss" scoped>
.search-wrap{
    padding: 34px;
}
.search-content{
    ul{
        display: grid;
        grid-template-columns: repeat(3, 356px);
        gap: 22px;
        margin: auto;
        justify-content: center;
        li{
            background: #ffffff;
            box-sizing: border-box;
            padding-bottom: 55px;
            cursor: pointer;
               img{
                   width: 356px;
                   height: 222px;
               }
            p{
                color:#2e2e2e;
                font-size:24px;
                margin-top: 15px;
                text-align: center;
            }

        }
    }
}
.pagination{
    text-align: center;
    margin:30px auto;
}
</style>
